class IglGallery extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    const select = (index, focus = false) => {
      const slides = [...this.querySelectorAll('[data-gallery-slide]')];
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        slide.inert = i !== index;
        slide.setAttribute('role', 'tabpanel');
        slide.setAttribute('aria-labelledby', `gallery-tab-${i}`);
        if (i !== index) {
          slide.querySelectorAll('video').forEach(video => video.pause());
          slide.querySelectorAll('iframe').forEach(frame => { frame.src = frame.src; });
        }
      });
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      if (focus) tabs[index]?.focus();
    };
    this.addEventListener('command', event => {
      if (event.command === '--select') select(Number(event.source.dataset.index));
    }, options);
    this.addEventListener('keydown', event => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      let index = tabs.indexOf(tab);
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else return;
      event.preventDefault(); select(index, true);
    }, options);
    if (this.querySelector('[role="tab"]')) select(0);
  }
  disconnectedCallback() { this.abort?.abort(); }
}
customElements.define('igl-gallery', IglGallery);
